

const decimalToMinutes = (value = 0) => {
  return Math.round(Number(value) * 60);
};

const decimalToHM = (value = 0) => {
  const updatedValue = Number(value);
  const h = Math.floor(updatedValue);
  const m = Math.round((updatedValue - h) * 60);
  return { hours: h, minutes: m };
};

const getHourMinuteText = (value) => {
  const { hours, minutes } = decimalToHM(value);

  if (hours === 0) {
    return `Calculated time : ${minutes} minute${minutes !== 1 ? "s" : ""}`;
  }
  if (minutes === 0) {
    return `Calculated time : ${hours} hour${hours !== 1 ? "s" : ""}`;
  }
  return `Calculated time : ${hours} hour${hours !== 1 ? "s" : ""} ${minutes} minute${minutes !== 1 ? "s" : ""}`;
};
const timeToMinutes = (time) => {
  if (!time) return 0;
  const [h, m] = time.split(":").map(Number);
  return (h * 60) + m;
};

const convertHoursMinutesFormat = (minutes) => {
  if (!minutes) return 0;
  // Convert to HH:MM
  const hh = String(Math.floor(minutes / 60)).padStart(2, "0");
  const mm = String(minutes % 60).padStart(2, "0");

  return `${hh}:${mm}`;
}

const decimalToTimeFormat = (value) => {
  const totalMinutes = decimalToMinutes(value);
  return convertHoursMinutesFormat(totalMinutes);
}
export { decimalToMinutes, decimalToHM, timeToMinutes, getHourMinuteText, convertHoursMinutesFormat, decimalToTimeFormat };